import { render, staticRenderFns } from "./DeleteRKIRegistration.vue?vue&type=template&id=4959aa09&"
import script from "./DeleteRKIRegistration.vue?vue&type=script&lang=js&"
export * from "./DeleteRKIRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRKIRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports